import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Landing from './views/Landing';

import { BrowserRouter, Routes, Route } from "react-router-dom";
import SpekHp from './views/pages/policy/SpekHP';
import Palontaraki from './views/pages/policy/Palontaraki';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode sx={{bgcolor: '#1C0A00'}}>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />}/>
        <Route path="/spekhp" element={<SpekHp />} />
        <Route path="/palontaraki" element={<Palontaraki />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
reportWebVitals();
